<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr && form.beforeStr.customer">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="title-box"><span class="txt1">{{[6,7,8].includes(form.beforeStr.customer.c_level)?'客户':'业务员' }}信息</span></div>
          <div class="item">姓名：{{form.beforeStr.customer.name}}</div>
          <div class="item">手机号：{{form.beforeStr.customer.pho}}</div>
          <div class="item">身份：{{setLevel(form.beforeStr.customer.c_level)}}</div>
          <div class="item">城市公司：{{getCompanyName(form.beforeStr.customer.city_company_id)}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">折扣组：{{setDiscount(form.beforeStr.customer.profit_ratio_id)}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">门店类型：{{form.beforeStr.customer.shop_type}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">日均门诊量：{{form.beforeStr.customer.shop_outpatient}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">员工数量：{{form.beforeStr.customer.shop_count}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">正在开展项目：{{form.beforeStr.customer.carry_projects}}</div>
          <div class="item"  v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">微信号：{{form.beforeStr.customer.wechat}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">意向度：{{form.beforeStr.customer.intention_level}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">备注：{{form.beforeStr.customer.note}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">客户来源：{{form.beforeStr.customer.source}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">用友编码：{{form.beforeStr.customer.yonyou_code}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">账号类型：{{form.beforeStr.customer.main_id?'子账号':'主账号'}}</div>
          <div class="item">所属业务员：{{form.beforeStr.parentCustomer.name}}</div>
          <div class="item" v-if="![6,7,8].includes(form.beforeStr.customer.c_level)">授权状态：{{form.beforeStr.customer.state?'已授权':'未授权'}}</div>
          <div class="item" v-if="![6,7,8].includes(form.beforeStr.customer.c_level)">状态：{{!form.beforeStr.customer.is_departed?'在职':form.beforeStr.customer.is_departed==1?'离职':'离职交接中'}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">技术老师：{{form.beforeStr.technician.real_name}}</div>
          <div class="item" v-if="[6,7,8].includes(form.beforeStr.customer.c_level)">是否公海客户：{{form.beforeStr.customer.is_open_sea?'是':'否'}}</div>
          <div class="item" v-if="form.beforeStr.customer && form.beforeStr.customer.last_donote">修改身份备注：{{form.beforeStr.customer.last_donote}}</div>
          <div class="item" v-if="splitVoucher(form.beforeStr.customer && form.beforeStr.customer.last_apply_voucher).length">
            修改身份附件：
            <el-image
              v-for="(url, idx) in splitVoucher(form.beforeStr.customer.last_apply_voucher)"
              :key="idx"
              style="width: 60px; height: 60px; margin-right: 8px; vertical-align: middle;"
              :src="url"
              :preview-src-list="splitVoucher(form.beforeStr.customer.last_apply_voucher)"
              fit="cover"
            ></el-image>
          </div>
          <div class="item" v-if="form.beforeStr.customer.is_open_sea &&[6,7,8].includes(form.beforeStr.customer.c_level) ">移入公海时间：{{form.beforeStr.customer.open_sea_time}}</div>
          <div class="item" v-if="form.beforeStr.customer.is_open_sea && form.beforeStr.customer.open_sea_reason && [6,7,8].includes(form.beforeStr.customer.c_level)">移入公海原因：{{form.beforeStr.customer.open_sea_reason}}</div>
          <div class="title-box" v-if="form.beforeStr.certificates"><span class="txt1">认证信息</span></div>
          <template v-if="form.beforeStr.certificates">
            <div class="item">认证类型：{{form.beforeStr.certificates.certificates_type==1?'企业认证':'个人认证'}}</div>
            <div class="item" v-if="form.beforeStr.certificates.certificates_type==2">姓名：{{form.beforeStr.certificates.company_name}}</div>
            <div class="item" v-if="form.beforeStr.certificates.certificates_type==2">身份证号：{{form.beforeStr.certificates.code}}</div>
            <div class="item" v-if="form.beforeStr.certificates.certificates_type==1">门店类型：{{form.beforeStr.certificates.company_type}}</div>
            <div class="item" v-if="form.beforeStr.certificates.certificates_type==1">企业全称：{{form.beforeStr.certificates.company_name}}</div>
            <div class="item" v-if="form.beforeStr.certificates.certificates_type==1">资质证件类型：{{form.beforeStr.certificates.company_zi_zhi==1?'医疗机构职业许可证':'营业执照'}}</div>
            <div class="item" v-if="form.beforeStr.certificates.certificates_type==1">资质证件凭证：
              <el-image
                  style="width: 100px; "
                  :src="form.beforeStr.certificates.certificates_img"
                  :preview-src-list="[form.beforeStr.certificates.certificates_img]">
                </el-image>
            </div>
            <div class="item" v-if="form.beforeStr.certificates.certificates_type==1">统一社会信用代码/登记号：{{form.beforeStr.certificates.code}}</div>
            <div class="item" v-if="form.beforeStr.certificates.certificates_type==1">纳税人识别号：{{form.beforeStr.certificates.taxpayer_code}}</div>
          </template>
          <div class="title-box" v-if="form.beforeStr.registration"><span class="txt1">报名信息</span></div>
          <template v-if="form.beforeStr.registration">
            <div class="item">报名费用：{{form.beforeStr.registration.fee}}</div>
            <div class="item">付款凭证：
              <el-image
                 v-for="item in form.beforeStr.registration.payList" :key="item.id"
                  style="width: 100px; "
                  :src="item.pay_img"
                  :preview-src-list="[item.pay_img]">
                </el-image>
            </div>
            <div class="item" v-if="form.beforeStr.registration.apply_voucher">申请凭证：
              <el-image
                v-for="(item,index) in form.beforeStr.registration.apply_voucher.split('#')" :key="index"
                  style="width: 100px; "
                  :src="item"
                  :preview-src-list="[item]">
                </el-image>
            </div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr && form.afterStr.customer">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="title-box"><span class="txt1">{{[6,7,8].includes(form.afterStr.customer.c_level)?'客户':'业务员' }}信息</span></div>
            <div class="item">姓名：{{form.afterStr.customer.name}}</div>
            <div class="item">手机号：{{form.afterStr.customer.pho}}</div>
            <div class="item">身份：{{setLevel(form.afterStr.customer.c_level)}}</div>
            <div class="item">城市公司：{{getCompanyName(form.afterStr.customer.city_company_id)}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">折扣组：{{setDiscount(form.afterStr.customer.profit_ratio_id)}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">门店类型：{{form.afterStr.customer.shop_type}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">日均门诊量：{{form.afterStr.customer.shop_outpatient}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">员工数量：{{form.afterStr.customer.shop_count}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">正在开展项目：{{form.afterStr.customer.carry_projects}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">微信号：{{form.afterStr.customer.wechat}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">意向度：{{form.afterStr.customer.intention_level}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">备注：{{form.afterStr.customer.note}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">客户来源：{{form.afterStr.customer.source}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">用友编码：{{form.afterStr.customer.yonyou_code}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">账号类型：{{form.afterStr.customer.main_id?'子账号':'主账号'}}</div>
            <div class="item">所属业务员：{{form.afterStr.parentCustomer.name}}</div>
            <div class="item" v-if="![6,7,8].includes(form.afterStr.customer.c_level)">授权状态：{{form.afterStr.customer.state?'已授权':'未授权'}}</div>
            <div class="item" v-if="![6,7,8].includes(form.afterStr.customer.c_level)">状态：{{!form.afterStr.customer.is_departed?'在职':form.afterStr.customer.is_departed==1?'离职':'离职交接中'}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">技术老师：{{form.afterStr.technician.real_name}}</div>
            <div class="item" v-if="[6,7,8].includes(form.afterStr.customer.c_level)">是否公海客户：{{form.afterStr.customer.is_open_sea?'是':'否'}}</div>
            
          <div class="item" v-if="form.afterStr.customer && form.afterStr.customer.last_donote">修改身份备注：{{form.afterStr.customer.last_donote}}</div>
            <div class="item" v-if="splitVoucher(form.afterStr.customer && form.afterStr.customer.last_apply_voucher).length">
              修改身份附件：
              <el-image
                v-for="(url, idx) in splitVoucher(form.afterStr.customer.last_apply_voucher)"
                :key="idx"
                style="width: 60px; height: 60px; margin-right: 8px; vertical-align: middle;"
                :src="url"
                :preview-src-list="splitVoucher(form.afterStr.customer.last_apply_voucher)"
                fit="cover"
              ></el-image>
            </div>
            <div class="item" v-if="form.afterStr.customer.is_open_sea && [6,7,8].includes(form.afterStr.customer.c_level)">移入公海时间：{{form.afterStr.customer.open_sea_time}}</div>
            <div class="item" v-if="form.afterStr.customer.is_open_sea && form.afterStr.customer.open_sea_reason && [6,7,8].includes(form.afterStr.customer.c_level)">移入公海原因：{{form.afterStr.customer.open_sea_reason}}</div>
            <div class="title-box" v-if="form.afterStr.certificates"><span class="txt1">认证信息</span></div>
            <template v-if="form.afterStr.certificates">
              <div class="item">认证类型：{{form.afterStr.certificates.certificates_type==1?'企业认证':'个人认证'}}</div>
              <div class="item" v-if="form.afterStr.certificates.certificates_type==2">姓名：{{form.afterStr.certificates.company_name}}</div>
              <div class="item" v-if="form.afterStr.certificates.certificates_type==2">身份证号：{{form.afterStr.certificates.code}}</div>
              <div class="item" v-if="form.afterStr.certificates.certificates_type==1">门店类型：{{form.afterStr.certificates.company_type}}</div>
              <div class="item" v-if="form.afterStr.certificates.certificates_type==1">企业全称：{{form.afterStr.certificates.company_name}}</div>
              <div class="item" v-if="form.afterStr.certificates.certificates_type==1">资质证件类型：{{form.afterStr.certificates.company_zi_zhi==1?'医疗机构职业许可证':'营业执照'}}</div>
              <div class="item" v-if="form.afterStr.certificates.certificates_type==1">资质证件凭证：
                <el-image
                    style="width: 100px; "
                    :src="form.afterStr.certificates.certificates_img"
                    :preview-src-list="[form.afterStr.certificates.certificates_img]">
                  </el-image>
              </div>
              <div class="item" v-if="form.afterStr.certificates.certificates_type==1">统一社会信用代码/登记号：{{form.afterStr.certificates.code}}</div>
              <div class="item" v-if="form.afterStr.certificates.certificates_type==1">纳税人识别号：{{form.afterStr.certificates.taxpayer_code}}</div>
            </template>
            <div class="title-box" v-if="form.afterStr.registration"><span class="txt1">报名信息</span></div>
            <template v-if="form.afterStr.registration">
              <div class="item">报名费用：{{form.afterStr.registration.fee}}</div>
              <div class="item">付款凭证：
                <el-image
                   v-for="item in form.afterStr.registration.payList" :key="item.id"
                    style="width: 100px; "
                    :src="item.pay_img"
                    :preview-src-list="[item.pay_img]">
                  </el-image>
              </div>
              <div class="item" v-if="form.afterStr.registration.apply_voucher">申请凭证：
                <el-image
                  v-for="(item,index) in form.afterStr.registration.apply_voucher.split('#')" :key="index"
                    style="width: 100px; "
                    :src="item"
                    :preview-src-list="[item]">
                  </el-image>
              </div>
            </template>
          </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
import sysProfitRatioApi from '@/api/sys/sysProfitRatio'
import clientListApi from '@/api/client/clientList'
import technicianInfoApi from '@/api/technical/technicianInfo'
import cityCompanyApi from '@/api/sys/cityCompany'
// import sysDeptApi from '@/api/sys/sysDept'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      sectionList:[],
      levelOption:[],
      discountList:[],
      technicianList:[],
      businessList:[],
      cityCompanyList: [] // 存储城市公司列表
    }
  },
  async created() {
    this.levelOption=JSON.parse(localStorage.getItem('levelList'))
    await this.getDiscountList()
    await this.getCityCompanyList()
    // await this.getTechnicianList()
    // await this.getBusinessList()
    // await this.getOption()
    this.getLogShow()
  },
  methods: {
    // customer.last_apply_voucher 存的是逗号分隔的 url，快照里是原始列名（下划线）
    splitVoucher(raw) {
      return raw ? String(raw).split(',').filter(i => i) : []
    },
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    },
    // 获取城市公司列表（只请求一次）
    async getCityCompanyList() {
      try {
        const res = await cityCompanyApi.getOption();
       
        this.cityCompanyList = res.data || [];
        
      } catch (error) {
       
        this.cityCompanyList = [];
      }
    },
    // 获取城市公司名字（从列表中过滤）
    getCompanyName(id) {
      if (!id) return '-';
      
      const company = this.cityCompanyList.find(item => item.key === id);
     
      return company ? company.value : id;
    },
    setLevel(val){
      return this.levelOption.find(i=>i.level==val).name
    },
    // 获取折扣组列表
    getDiscountList(){
      sysProfitRatioApi.fetchList({isEnable:1}).then(({data})=>{
        this.discountList=data
      })
    },
    // 获取技术老师列表
    getTechnicianList(){
      technicianInfoApi.listForMini({
        // isGetAllParent:true,
        status: 10}).then(({data})=>{
        this.technicianList=data
      })
    },
    // 获取业务员列表
    getBusinessList(){
      // clientListApi.listForMini({customerTypes:2,isGetAllParent:true,isDeparted:0}).then(({data})=>{
      //   this.businessList=data
      //   // console.log('业务员列表: ',data);
      // })
    },
    setDiscount(id){
      let obj=this.discountList.find(i=>i.id==id)
      return obj?obj.title:id
    },
    // setTechnician(id){
    //   if(!id) return
    //   // technicianInfoApi.listForMini({isGetAllParent:true,status: 10}).then(({data})=>{
    //   //   this.technicianList=data
    //   // })
    //   let obj=this.technicianList.find(i=>i.id==id)
    //   if(obj){
    //     return obj.realName
    //   }else{
    //     return id
    //   }
    // },
    // setBusiness(id){
    //   if(!id) return
    //   // clientListApi.listForMini({customerTypes:2,isGetAllParent:true,isDeparted:0}).then(({data})=>{
    //   //   this.businessList=data
    //   //   // console.log('业务员列表: ',data);
    //   // })
    //   let obj=this.businessList.find(i=>i.id==id)
    //   if(obj){
    //     return obj.realName
    //   }else{
    //     return id
    //   }
    //   // return this.businessList.find(i=>i.id==id).name
    // }
    // getOption(){
    //   sysDeptApi.findOptions().then(({data})=>{
    //     this.sectionList=data
    //   })
    // },
    // setDept(id){
    //   return this.sectionList.find(i=>i.key==id).value
    // }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
